import { createContext } from 'react';

// keeps field ids unique when the same form renders twice on a page
export const FieldIdSuffixContext = createContext('');
